import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";

var root = $.from_html(`<span class="slex-step-progress"> </span>`);
var root_1 = $.from_html(`<h3> </h3>`);
var root_2 = $.from_html(`<p> </p>`);
var root_3 = $.from_html(`<section class="slex-step"><header class="slex-step-header"><div class="slex-step-heading"><!> <!></div> <div><!></div></header> <div class="slex-step-body"></div></section>`);

export default function Step($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function progress() {
		if ($.get(p).progress) return text($.get(p).progress);

		const current = $.get(p).index ?? $.get(p).number;

		if (!current) return "";
		if ($.get(p).total) return `${text(current)}/${text($.get(p).total)}`;

		return text(current);
	}

	var section = root_3();
	var header = $.child(section);
	var div = $.child(header);
	var node = $.child(div);

	{
		var consequent = ($$anchor) => {
			var span = root();
			var text_1 = $.child(span, true);

			$.reset(span);
			$.template_effect(($0) => $.set_text(text_1, $0), [() => progress()]);
			$.append($$anchor, span);
		};

		var d = $.derived(() => progress());

		$.if(node, ($$render) => {
			if ($.get(d)) $$render(consequent);
		});
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_1 = ($$anchor) => {
			var h3 = root_1();
			var text_2 = $.child(h3, true);

			$.reset(h3);
			$.template_effect(($0) => $.set_text(text_2, $0), [() => text($.get(p).title)]);
			$.append($$anchor, h3);
		};

		$.if(node_1, ($$render) => {
			if ($.get(p).title) $$render(consequent_1);
		});
	}

	$.reset(div);

	var div_1 = $.sibling(div, 2);
	var node_2 = $.child(div_1);

	{
		var consequent_2 = ($$anchor) => {
			var p_1 = root_2();
			var text_3 = $.child(p_1, true);

			$.reset(p_1);
			$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(p).description)]);
			$.append($$anchor, p_1);
		};

		$.if(node_2, ($$render) => {
			if ($.get(p).description) $$render(consequent_2);
		});
	}

	$.reset(div_1);
	$.reset(header);

	var div_2 = $.sibling(header, 2);

	$.action(div_2, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);
	$.reset(section);
	$.template_effect(($0) => $.set_attribute(section, 'data-state', $0), [() => $.get(p).state ? text($.get(p).state) : undefined]);
	$.append($$anchor, section);
	$.pop();
}